exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".piBUqOici5jOMLj0y3fLk{width:100%;margin:14.28571vw 0}@media (min-width:1024px){.piBUqOici5jOMLj0y3fLk{margin:7.14286vw 0}}", "", {"version":3,"sources":["/app/Interface/src/components/Gallery/Gallery.css"],"names":[],"mappings":"AAiBA,uBACE,WAAY,AACZ,mBAAqB,CACtB,AACD,0BACE,uBACE,kBAAoB,CACrB,CACF","file":"Gallery.css","sourcesContent":["/* Define Custom Media queries */\n/* Define global CSS variables inside :root */\n:root {\n  /* Set the default font size */\n\n  /* Colors */\n\n  /* Set the default font to use on the site */\n\n  /* For info-screens only */\n\n  /* Menu */\n\n  /* Framer */\n\n  /* Audio Guide */ /* Intended to maintain layout on desktop as only designed for mobile */\n}\n.Gallery {\n  width: 100%;\n  margin: 14.28571vw 0;\n}\n@media (min-width: 1024px) {\n  .Gallery {\n    margin: 7.14286vw 0;\n  }\n}"],"sourceRoot":""}]);

// exports
exports.locals = {
	"Gallery": "piBUqOici5jOMLj0y3fLk"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"modules":true,"minimize":true,"sourceMap":true}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null,null,null,null]}!./src/components/Gallery/Gallery.css
// module id = 622
// module chunks = 0